export default {
  applePayOption: 'applepay',
  cardOption: 'card',
};
